import { Autocomplete, TextField } from "@mui/material"
import BackspaceIcon from "@mui/icons-material/Backspace"

export const renderEditCellAutocomplete = (options) => (params) => {
  const value = options.find(o => o.id === params.value) || null

  return (
    <Autocomplete
      autoFocus
      openOnFocus
      fullWidth
      size="small"
      options={options}
      value={value}
      clearIcon={<BackspaceIcon fontSize="small" color="secondary" />}
      onChange={async (e, newValue) => {
        await params.api.setEditCellValue({
          id: params.id,
          field: params.field,
          value: newValue ? newValue.id : null,
        })
        params.api.commitCellChange({ id: params.id, field: params.field })
        params.api.setCellMode(params.id, params.field, "view")
      }}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      renderInput={(p) => <TextField {...p} variant="standard" autoFocus />}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>{option.label}</li>
      )}
    />
  )
}